import React from 'react';
import OfficeMap from './OfficeMap';

const OfficeInfo = ({ offices = [], selectedIndex = 0, apiKey }) => (
   <div className="c-OfficeInfo">
    <OfficeMap
      apiKey={apiKey}
      marker={offices[selectedIndex].coordinate}
    />
    <div className="c-OfficeInfo__info">
    {offices.map((office, idx) => (
      <div key={office.id} className={idx !== selectedIndex ? 'u-display-hidden' : ''}>
        <ul>
          <li>{office.name}</li>
          <li dangerouslySetInnerHTML={{ __html : formatAddress(office.address)}}></li>
          <li className="c-OfficeInfo__telephone">
            <a className="c-OfficeInfo__telephone--link" href={formatTelephone(office.telephone)}>
              <span className="u-text-bold u-padding-small-right">T</span>
              {office.telephone}
            </a>
          </li>
          {fax(office.fax)}
        </ul>
      </div>
    ))}
    </div>
   </div>
);

const formatTelephone = (telephone) => {
  telephone = telephone.replace(' ', '');
  return "tel:" + telephone;
};

const fax = (fax) => {
  if (false == fax) {
    return "";
  }
  return (
    <li>
      <span className="u-text-bold u-padding-small-right">F</span>
      {fax}
    </li>
  )
};

const formatAddress = (str) => {
  return str.replace(/(?:\r\n|\r|\n)/g, '<br />');
};

export default OfficeInfo



// WEBPACK FOOTER //
// ./plugins/app/site/pagesections/officetabs/js/OfficeInfo.js